import React from "react";
import { SEO, AccountingMain, AdminLayout } from "../../../components";

const AccountingMainPage = () => {
  return (
    <>
      <SEO title="Accounting" />
      <AdminLayout>
        <AccountingMain />
      </AdminLayout>
    </>
  );
};

export default AccountingMainPage;
